import React from "react";
import { Typography } from "@mui/material";

export const payDialogOn = true; // enables Stripe / P24 confirmation modal

export const MONTHS_PL = {
  1: "Stycznia",
  2: "Lutego",
  3: "Marca",
  4: "Kwietnia",
  5: "Maja",
  6: "Czerwca",
  7: "Lipca",
  8: "Sierpnia",
  9: "Września",
  10: "Października",
  11: "Listopada",
  12: "Grudnia",
};

export const AcceptRegulaminLabel = (
  <Typography variant="body2">
    Akceptuję {""}
    <a href={`${process.env.PUBLIC_URL}/statute`} target="_blank" rel="noopener noreferrer">
      Regulamin
    </a>
  </Typography>
);
